// advup — missão PWA mobile 2026-07-20 (pedido do Victor: quem já tem o app
// instalado precisa pegar a atualização sozinho, "como se fosse update de
// app"). O sw.js atual só cuida de push notification, não tem cache nem
// versionamento — então o mecanismo aqui é feito por polling: consulta
// /pwa_version (mtime do manifest do Vite, muda em todo deploy) e recarrega
// a página quando detecta uma versão diferente da que carregou.
//
// Só roda em modo standalone (PWA instalado, display-mode: standalone / o
// fallback navigator.standalone do iOS) — de propósito, pra não mexer em
// nada de quem usa pelo navegador normal no desktop/notebook.
import { isPwaBusy } from './pwaReloadGuard';

const CHECK_INTERVAL_MS = 10 * 60 * 1000;
// Achado real 2026-07-30: recarregar sem checar se o usuário está no meio
// de gravar/enviar um áudio derrubava a mensagem em andamento — se
// `isPwaBusy()`, adia o reload e tenta de novo nesse intervalo curto em
// vez de esperar o próximo poll de 10min ou o próximo visibilitychange.
const PENDING_RELOAD_RETRY_MS = 3 * 1000;

function isStandalonePwa() {
  if (window.matchMedia?.('(display-mode: standalone)').matches) return true;
  return !!window.navigator.standalone;
}

async function fetchBuildVersion() {
  const response = await fetch('/pwa_version', { cache: 'no-store' });
  if (!response.ok) return null;
  const { version } = await response.json();
  return version;
}

export function usePwaAutoUpdate() {
  if (!isStandalonePwa()) return;

  let currentVersion = null;
  let checking = false;
  let pendingReloadTimer = null;

  const reloadWhenIdle = () => {
    if (pendingReloadTimer) return;
    const attempt = () => {
      if (isPwaBusy()) {
        pendingReloadTimer = setTimeout(attempt, PENDING_RELOAD_RETRY_MS);
        return;
      }
      window.location.reload();
    };
    attempt();
  };

  const checkForUpdate = async () => {
    if (checking) return;
    checking = true;
    try {
      const latestVersion = await fetchBuildVersion();
      if (!latestVersion) return;
      if (currentVersion === null) {
        currentVersion = latestVersion;
      } else if (latestVersion !== currentVersion) {
        reloadWhenIdle();
      }
    } catch (error) {
      // Falha de rede não deve travar o app — só tenta de novo na próxima.
    } finally {
      checking = false;
    }
  };

  checkForUpdate();
  setInterval(checkForUpdate, CHECK_INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkForUpdate();
  });
}
